<template>
  <div class="tx-dealersearch module-google-map" ref="container">
    <div class="map-wrapper" ref="wrapper">
      <div :id="id" :ref="id">
      </div>
    </div>
  </div>
</template>

<script>
/* global google */
import { mapState } from 'vuex'

export default {
  name: 'GoogleMap',
  inject: ['apiBase', 'detailListingBase', 'mobile', 'phone'],
  data () {
    return {
      map: null,
      mapBounds: {},
      markerIconPoi: {
        url: '',
        size: new google.maps.Size(36, 58),
        origin: new google.maps.Point(0, 0),
        anchor: new google.maps.Point(18, 58),
        scaledSize: new google.maps.Size(36, 58)
      },
      markerIconPoiActive: {
        url: '',
        size: new google.maps.Size(46, 74),
        origin: new google.maps.Point(0, 0),
        anchor: new google.maps.Point(23, 74),
        scaledSize: new google.maps.Size(46, 74)
      },
      markerClickPopups: [],
      lastClickedIndex: -1,
      defaultDealerPicURL: ''
    }
  },
  props: {
    id: {
      type: String,
      default: 'map'
    },
    hoveredPoiIndex: {
      type: Number,
      default: -1
    },
    clickedPoiIndex: {
      type: Number,
      default: -1
    }
  },
  computed: {
    ...mapState({
      mandant: state => state.mandant,
      moreLoaded: state => state.moreLoaded,
      pois: state => state.dealer.dealers,
      latitudeSearched: state => state.latitude,
      longitudeSearched: state => state.longitude
    })
  },
  watch: {
    pois: function (newPois) {
      const self = this
      self.$emit('closedPoiIndex')

      if (self.markers) {
        for (let i = 0; i < self.markers.length; i++) {
          self.markers[i].setMap(null)
        }
      }
      self.markers = []
      self.mapBounds = new google.maps.LatLngBounds()

      if (newPois.length) {
        for (let i = 0; i < newPois.length; i++) {
          self.addMapMarker(self, newPois[i], i)
        }
        if (!self.bounds) {
          self.map.fitBounds(self.mapBounds)
        }
      } else {
        if (self.latitudeSearched && self.longitudeSearched) {
          self.map.setCenter({ lat: self.latitudeSearched, lng: self.longitudeSearched })
        } else {
          self.map.setCenter({ lat: 48.0532510192798, lng: 12.770071628931637 })
        }
        self.map.setZoom(13)
      }
    },
    hoveredPoiIndex: function (newHoveredPoi, oldHoveredPoi) {
      const self = this
      if (oldHoveredPoi >= 0) {
        self.markers[oldHoveredPoi].setIcon(self.markerIconPoi)
        self.markerClickPopups[oldHoveredPoi].setMap(null)
        self.$emit('closedPoiIndex')
      }
      if (newHoveredPoi >= 0) {
        self.markers[newHoveredPoi].setIcon(self.markerIconPoiActive)
        self.openClickPopup(self, self.pois[newHoveredPoi], newHoveredPoi)
      }
    },
    clickedPoiIndex: function (newClickedPoi, oldClickedPoi) {
      const self = this
      if (oldClickedPoi >= 0 && self.markers[oldClickedPoi]) {
        self.markers[oldClickedPoi].setIcon(self.markerIconPoi)
      }
      if (newClickedPoi >= 0) {
        self.markers[newClickedPoi].setIcon(self.markerIconPoiActive)
      }
    }
  },
  mounted () {
    const self = this

    self.markerIconPoi.url = require('@/assets/icon-map-marker-' + this.mandant + '.png')
    self.markerIconPoiActive.url = require('@/assets/icon-map-marker-active-' + this.mandant + '.png')
    self.defaultDealerPicURL = require('@/assets/' + this.mandant + '-dealer-search-image-default.jpg')

    const center = { lat: 48.0532510192798, lng: 12.770071628931637 }
    if (self.latitudeSearched && self.longitudeSearched) {
      center.lat = parseFloat(self.latitudeSearched)
      center.lng = parseFloat(self.longitudeSearched)
    }

    self.map = new google.maps.Map(self.$refs[self.id], {
      center: center,
      scrollwheel: !self.mobile,
      zoom: 13,
      minZoom: null,
      maxZoom: 18,
      fullscreenControl: false,
      mapTypeControl: false,
      streetViewControl: false,
      styles: [
        {
          featureType: 'poi',
          stylers: [{ visibility: 'off' }]
        }
      ]
    })

    self.mapBounds = new google.maps.LatLngBounds()
    if (self.pois.length) {
      self.markers = []
      for (let i = 0; i < self.pois.length; i++) {
        self.addMapMarker(self, self.pois[i], i)
      }
      if (!self.bounds) {
        self.map.fitBounds(self.mapBounds)
      }
    }
  },
  methods: {
    plainName: function (name) {
      return name ? name.replace(/<[^>]*>/g, ' ').replace(/\s+/g, ' ').trim() : ''
    },
    createPopupClass: function () {
      function Popup (position, content) {
        this.position = position
        this.content = content

        // Optionally stop clicks, etc., from bubbling up to the map.
        google.maps.OverlayView.preventMapHitsAndGesturesFrom(this.content)
      }

      // ES5 magic to extend google.maps.OverlayView.
      Popup.prototype = Object.create(google.maps.OverlayView.prototype)

      /** Called when the popup is added to the map. */
      Popup.prototype.onAdd = function () {
        this.getPanes().floatPane.appendChild(this.content)
      }

      /** Called when the popup is removed from the map. */
      Popup.prototype.onRemove = function () {
        if (this.content.parentElement) {
          this.content.parentElement.removeChild(this.content)
        }
      }

      /** Called each frame when the popup needs to draw itself. */
      Popup.prototype.draw = function () {
        const divPosition = this.getProjection().fromLatLngToDivPixel(this.position)

        // Hide the popup when it is far out of view.
        const display =
          Math.abs(divPosition.x) < 4000 && Math.abs(divPosition.y) < 4000
            ? 'block'
            : 'none'
        if (display === 'block') {
          this.content.style.left = divPosition.x + 'px'
          this.content.style.top = divPosition.y + 'px'
        }
        if (this.content.style.display !== display) {
          this.content.style.display = display
        }
      }

      return Popup
    },
    addMapMarker: function (self, poi, index) {
      const LatLng = new google.maps.LatLng(poi.lat, poi.lng)
      self.markers[index] = new google.maps.Marker({
        position: LatLng,
        title: self.plainName(poi.name),
        icon: self.markerIconPoi
      })

      self.markers[index].addListener('click', function () {
        self.$emit('clickedPoiIndex', self.pois.indexOf(poi))
        self.openClickPopup(self, poi, index)
      })

      if (!this.bounds) {
        self.mapBounds.extend(LatLng)
      }
      self.markers[index].setMap(self.map)
    },
    openClickPopup: function (self, poi, index) {
      const LatLng = new google.maps.LatLng(poi.lat, poi.lng)

      const module = document.createElement('div')
      module.classList.add('module-map-popup')
      if (self.mobile) {
        module.classList.add('-mobile')
      }
      const imageSrc = poi.image ? poi.image.split('|')[0] : self.defaultDealerPicURL
      const wrapper = document.createElement('div')
      wrapper.classList.add('map-popup-wrapper')
      wrapper.innerHTML = '<div class="map-popup__image">' +
          '<img src="' + imageSrc + '" alt="' + (self.plainName(poi.name) + ' Logo') + '">' +
          '</div>' +
          '<div class="map-popup__content">' +
          '<div class="content__name heading epsilon"><span>' + poi.name + '</span></div>' +
          '<div class="content__company"><span>' + poi.contactPerson + '</span></div>' +
          '<div class="content__street"><span>' + poi.street + '</span></div>' +
          '<div class="content__city"><span>' + poi.zip + ' ' + poi.city + '</span></div>' +
          '<div class="content__link"><a class="link" href="' + self.detailListingBase + poi.slug + '/' + '"><span>' + self.$i18n.t('dealersearch.map.popup.button') + '</span></a></div>' +
          '</div>'
      module.appendChild(wrapper)
      const close = document.createElement('div')
      close.classList.add('map-popup-close')
      close.addEventListener('click', function () {
        self.$emit('closedPoiIndex')
        module.parentElement.removeChild(module)
      })
      module.appendChild(close)

      self.map.addListener('click', function () {
        if (self.lastClickedIndex >= 0) {
          self.markerClickPopups[self.lastClickedIndex].setMap(null)
          self.$emit('closedPoiIndex')
        }
      })

      if (self.lastClickedIndex >= 0) {
        self.markerClickPopups[self.lastClickedIndex].setMap(null)
        self.$emit('closedPoiIndex')
      }

      if (self.markerClickPopups[index]) {
        self.markerClickPopups[index].setMap(null)
        self.$emit('closedPoiIndex')
      }

      const Popup = self.createPopupClass()
      self.markerClickPopups[index] = new Popup(LatLng, module)

      self.markerClickPopups[index].setMap(self.map)
      self.$emit('clickedPoiIndex', index)
      self.lastClickedIndex = index
      self.skipListeners = false
    }
  }
}
</script>
